/**
 * GuideKeycap — styled inline element that visually renders a key like
 * "⌘ K" or "Ctrl + Shift + F". Used in the Hotkeys section + scattered
 * inline through the guide.
 */
import React from 'react';
import { Box } from '@mui/material';
import { useAppTheme } from '../../hooks/useAppTheme';

interface Props {
  children: React.ReactNode;
}

const GuideKeycap: React.FC<Props> = ({ children }) => {
  const { isDark } = useAppTheme();
  return (
    <Box
      component="kbd"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 0.6,
        py: 0.1,
        mx: 0.15,
        minWidth: 18,
        height: 20,
        justifyContent: 'center',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, monospace',
        fontSize: '0.72rem',
        fontWeight: 600,
        lineHeight: 1,
        color: 'text.primary',
        bgcolor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
        border: '1px solid',
        borderColor: isDark ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.15)',
        borderRadius: 0.6,
        boxShadow: isDark
          ? 'inset 0 -1px 0 rgba(255,255,255,0.06)'
          : 'inset 0 -1px 0 rgba(0,0,0,0.08)',
        verticalAlign: 'baseline',
      }}
    >
      {children}
    </Box>
  );
};

export default GuideKeycap;
